import { render } from "./tep-only-title.vue?vue&type=template&id=de71a326&scoped=true"
import script from "./tep-only-title.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-only-title.vue?vue&type=script&setup=true&lang=js"

import "./tep-only-title.vue?vue&type=style&index=0&id=de71a326&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de71a326"],['__file',"src/views/tep/tep-grid/components/tep-only-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de71a326"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de71a326', __exports__)) {
    api.reload('de71a326', __exports__)
  }
  
  module.hot.accept("./tep-only-title.vue?vue&type=template&id=de71a326&scoped=true", () => {
    api.rerender('de71a326', render)
  })

}


export default __exports__